import swal from "sweetalert";
import successIcon from './assets/success.png';
import errorIcon from './assets/error.png';
import warningIcon2 from './assets/warning.png';

const swalAlert = async (title, text, icon, buttons, buttonText = "Yes", dangerMode = true) => {

	let customIcon;
	// Dynamically assign custom icons and button colors
	if (icon === "success") {
		customIcon = successIcon;
	} else if (icon === "warning") {
		customIcon = warningIcon2;
	} else {
		customIcon = errorIcon;
	}
	// SweetAlert configuration
	let swalObj = {
		title,
		text,
		icon: customIcon, // Use the custom icon here
		dangerMode,
		buttons: buttons
			? {
				cancel: {
					text: "Cancel",
					value: false,
					visible: true,
					className: "btn-secondary",
					closeModal: true,
				},
				confirm: {
					text: buttonText,
					value: true,
					visible: true,
					className: `btn-custom-${icon}`,
					closeModal: true,
				},
			}
			: "Close",
	};

	// Return SweetAlert
	return swal(swalObj);
};

export default swalAlert;
